import { render, staticRenderFns } from "./formcontrol.vue?vue&type=template&id=20b2bea1&scoped=true&"
import script from "./formcontrol.vue?vue&type=script&lang=js&"
export * from "./formcontrol.vue?vue&type=script&lang=js&"
import style0 from "./formcontrol.vue?vue&type=style&index=0&id=20b2bea1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b2bea1",
  null
  
)

export default component.exports